// ------------------------------------
// CORES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';
    const ref2 = 'styles';

    // Elementos
    const $header = $('#header');

    // Cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['header-bg-color'];
      $header[0].style.setProperty('--header-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-bg-color', changeBgColor);

    // Cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['header-txt-color'];
      $header[0].style.setProperty('--header-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-txt-color', changeTxtColor);

    // Cor dos ícones
    function changeIconsColor() {
      const color = confTheme[ref][ref2]['header-icons-color'];
      $header[0].style.setProperty('--header-icons-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-icons-color', changeIconsColor);

    // Cor da borda
    function changeBorderColor() {
      const color = confTheme[ref][ref2]['header-border-color'];
      $header[0].style.setProperty('--header-border-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-border-color', changeBorderColor);
  }
})();

// ------------------------------------
// LOGOTIPO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';

    // Elementos
    const $logo = $('.header-logo');
    const $logoImg = $logo.find('img');

    // Altera a imagem
    function changeLogoImage() {
      const image = confTheme[ref]['logo-src'];
      $logoImg.attr('src', image);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-src', changeLogoImage);

    // Altera o texto alternativo da imagem
    function changeLogoAlt() {
      const value = confTheme[ref]['logo-alt'];
      $logoImg.attr('alt', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-alt', changeLogoAlt);

    // Altera o tamanho da imagem
    function changeLogoSize() {
      const value = confTheme[ref]['styles']['logo-size'];
      $('#header')[0].style.setProperty('--logo-size', value);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-size', changeLogoSize);
    function changeLogoSizeMb() {
      const value = confTheme[ref]['styles']['logo-size-mb'];
      $('#header')[0].style.setProperty('--logo-size-mb', value);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-logo-size-mb', changeLogoSizeMb);

    // Altera logo centralizado forçado no celular
    function changeLogoForceCenter() {
      const value = confTheme[ref]['logo-force-center'];
      value == '1' ? $logo.addClass('force-center') : $logo.removeClass('force-center');
      fixCenterLogo();
    }
    $root.on(confEvtDefault + ' lp-evt-logo-force-center', changeLogoForceCenter);
  }
})();

// ------------------------------------
// BUSCA, ATENDIMENTO E RASTREIO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';
    const ref2 = 'styles';

    // Elementos
    const $busca = $('.header-search-wrp');
    const $buscaBtnMb = $('.header-search-btn-mb-wrp');
    const $buscaCats = $('.header-search-category');
    const $buscaPlaceholder = $('#header-search');
    const $rastreio = $('.header-rastreio-btn');
    const $rastreioMb = $('.menu-mobile-rastreio');
    const $atendimento = $('.header-button-wrp-atendimento');
    const $atendimentoMb = $('.menu-mobile-footer-atendimento');
    const $redesSociais = $('.menu-mobile-footer-sociais');
    const $loginLink = $('.header-login-btn');
    const $loginLinkMb = $('.menu-mobile-login');

    // Oculta/Exibe a busca
    function changeSearchShow() {
      const value = confTheme[ref]['search-show'];
      value == '1' ? $busca.removeClass('d-none') : $busca.addClass('d-none');
      value == '1' ? $buscaBtnMb.removeClass('d-none') : $buscaBtnMb.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-search-show', changeSearchShow);
    function changeSearchMbShow() {
      const value = confTheme[ref]['search-mb-show'];
      value == '1' ? $buscaBtnMb.removeClass('d-none') : $buscaBtnMb.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-search-mb-show', changeSearchMbShow);

    // Oculta/Exibe as categorias na busca
    function changeSearchCatsShow() {
      const value = confTheme[ref]['search-cats-show'];
      value == '1' ? $buscaCats.removeClass('d-none') : $buscaCats.addClass('d-none');
      value == '1' ? $busca.addClass('search-w-cat') : $busca.removeClass('search-w-cat');
    }
    $root.on(confEvtDefault + ' lp-evt-search-cats-show', changeSearchCatsShow);

    // Ativa/Desativa busca expandida no celular
    function changeSearchExpanded() {
      const value = confTheme[ref]['search-expanded'];
      if (value == '1') {
        $('#header').addClass('search-expanded-mb');
        $('.header-search-wrp').addClass('search-expanded-mb');
        $('.header-search-btn-mb-wrp').addClass('search-expanded-mb');
      } else {
        $('#header').removeClass('search-expanded-mb');
        $('.header-search-wrp').removeClass('search-expanded-mb');
        $('.header-search-btn-mb-wrp').removeClass('search-expanded-mb');
      }
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-search-expanded', changeSearchExpanded);

    // Altera placeholder do campo de busca
    function changeSearchPlaceholder() {
      const value = confTheme[ref]['search-placeholder'];
      $buscaPlaceholder.attr('placeholder', value);
      if ($('#search-side-input').length) {
        $('#search-side-input').attr('placeholder', value);
      }
    }
    $root.on(confEvtDefault + ' lp-evt-search-placeholder', changeSearchPlaceholder);

    // Altera o tipo de busca
    function changeSearchType() {
      const value = confTheme[ref]['search-type'];
      if (value === 'side') {
        $('.header-search-wrp').addClass('d-none');
        $('.header-search-btn-mb-wrp').addClass('search-side-toggle-btn');
        $('.header-search-btn-mb').addClass('open-side-search');
        sideOpen('search-side');
      } else {
        $('.header-search-wrp').removeClass('d-none');
        $('.header-search-btn-mb-wrp').removeClass('search-side-toggle-btn');
        $('.header-search-btn-mb').removeClass('open-side-search');
        sideClose('search-side');
      }
    }
    $root.on(confEvtDefault + ' lp-evt-search-type', changeSearchType);

    // Oculta/Exibe o rastreio
    function changeRastreioShow() {
      const value = confTheme[ref]['rastreio-show'];
      value == '1' ? $rastreio.removeClass('d-none') : $rastreio.addClass('d-none');
      value == '1' ? $rastreioMb.removeClass('d-none') : $rastreioMb.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-rastreio-show', changeRastreioShow);
    function changeRastreioMbShow() {
      const value = confTheme[ref]['rastreio-mb-show'];
      value == '1' ? $rastreio.removeClass('d-none-sm d-none-xs') : $rastreio.addClass('d-none-sm d-none-xs');
    }
    $root.on(confEvtDefault + ' lp-evt-rastreio-mb-show', changeRastreioMbShow);

    // Oculta/Exibe atendimento
    function changeAtendimentoShow() {
      const value = confTheme[ref]['menu-atendimento-show'];
      value == '1' ? $atendimento.removeClass('d-none') : $atendimento.addClass('d-none');
      value == '1' ? $atendimentoMb.removeClass('d-none') : $atendimentoMb.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-menu-atendimento-show', changeAtendimentoShow);
    function changeAtendimentoMbShow() {
      const value = confTheme[ref]['menu-atendimento-mb-show'];
      value == '1'
        ? $atendimento.find('.header-button').removeClass('d-none-sm d-none-xs')
        : $atendimento.find('.header-button').addClass('d-none-sm d-none-xs');
    }
    $root.on(confEvtDefault + ' lp-evt-menu-atendimento-mb-show', changeAtendimentoMbShow);

    // Oculta/Exibe redes sociais (Menu mobile)
    function changeRedesSociaisShow() {
      const value = confTheme[ref]['menu-mb-social-show'];
      value == '1' ? $redesSociais.removeClass('d-none') : $redesSociais.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-menu-mb-social-show', changeRedesSociaisShow);

    // Cor de fundo da busca
    function changeSearchBgColor() {
      const color = confTheme[ref][ref2]['search-bg-color'];
      $root[0].style.setProperty('--search-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-search-bg-color', changeSearchBgColor);

    // Cor da borda da busca
    function changeSearchBorderColor() {
      const color = confTheme[ref][ref2]['search-border-color'];
      $root[0].style.setProperty('--search-border-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-search-border-color', changeSearchBorderColor);

    // Cor do texto da busca
    function changeSearchTxtColor() {
      const color = confTheme[ref][ref2]['search-txt-color'];
      $root[0].style.setProperty('--search-txt-color', color);
      if (color) {
        const placeColor = hexToRGBA(color, 0.75);
        $('.header-search')[0].style.setProperty('--search-place-color', placeColor);
        if ($('.search-side-form').length) {
          $('.search-side-form')[0].style.setProperty('--search-place-color', placeColor);
        }
      }
    }
    $root.on(confEvtDefault + ' lp-evt-search-txt-color', changeSearchTxtColor);

    // Cor do botão da busca
    function changeSearchBtnBgColor() {
      const color = confTheme[ref][ref2]['search-btn-bg-color'];
      $root[0].style.setProperty('--search-btn-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-search-btn-bg-color', changeSearchBtnBgColor);

    // Cor da borda botão da busca
    function changeSearchBtnBorderColor() {
      const color = confTheme[ref][ref2]['search-btn-border-color'];
      $root[0].style.setProperty('--search-btn-border-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-search-btn-border-color', changeSearchBtnBorderColor);

    // Cor do ícone botão da busca
    function changeSearchBtnIconColor() {
      const color = confTheme[ref][ref2]['search-btn-icon-color'];
      $root[0].style.setProperty('--search-btn-icon-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-search-btn-icon-color', changeSearchBtnIconColor);

    // Cor de fundo do contador do carrinho
    function changeBadgeBgColor() {
      const color = confTheme[ref][ref2]['header-badge-bg-color'];
      $root[0].style.setProperty('--header-badge-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-badge-bg-color', changeBadgeBgColor);

    // Cor do texto do contador do carrinho
    function changeBadgeTxtColor() {
      const color = confTheme[ref][ref2]['header-badge-txt-color'];
      $root[0].style.setProperty('--header-badge-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-badge-txt-color', changeBadgeTxtColor);

    // Ícone do carrinho
    function changeCartIcon() {
      const icon = confTheme[ref]['header-cart-icon'];
      $('.header-cart-btn .header-button-icon').html(getSvgIcon(icon) + '<span class="badge v-cart-count">0</span>');
      $('.dropdown-cart-empty-icon, .cart-side-empty-icon, .card-side-icon').html(getSvgIcon(icon));
    }
    $root.on(confEvtDefault + ' lp-evt-header-cart-icon', changeCartIcon);
    // Altera o tamanho do ícone
    function changeCartIconSize() {
      const value = confTheme[ref]['styles']['header-cart-icon-size'];
      $('#header')[0].style.setProperty('--header-cart-icon-size', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-cart-icon-size', changeCartIconSize);

    // Ícone do atendimento
    function changeAtendIcon() {
      const icon = confTheme[ref]['header-atend-icon'];
      $('.header-button-wrp-atendimento .header-button-icon').html(getSvgIcon(icon));
    }
    $root.on(confEvtDefault + ' lp-evt-header-atend-icon', changeAtendIcon);
    // Altera o tamanho do ícone
    function changeAtendIconSize() {
      const value = confTheme[ref]['styles']['header-atend-icon-size'];
      $('#header')[0].style.setProperty('--header-atend-icon-size', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-atend-icon-size', changeAtendIconSize);

    // Ícone do rastreio
    function changeTrackIcon() {
      const icon = confTheme[ref]['header-track-icon'];
      $('.header-rastreio-btn .header-button-icon').html(getSvgIcon(icon));
    }
    $root.on(confEvtDefault + ' lp-evt-header-track-icon', changeTrackIcon);
    // Altera o tamanho do ícone
    function changeTrackIconSize() {
      const value = confTheme[ref]['styles']['header-track-icon-size'];
      $('#header')[0].style.setProperty('--header-track-icon-size', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-track-icon-size', changeTrackIconSize);

    // Título carrinho
    function changeCartTit() {
      const value = confTheme[ref]['header-cart-tit'];
      let titTxt = value ? value.trim() : '';
      titTxt = mdParse(titTxt, true);
      const vCartTotal = $('.v-cart-total').last().text() || 'R$ 0,00';
      const vCartCount = $('.v-cart-count').last().text() || '0';
      titTxt = titTxt.replace('{{v-cart-total}}', vCartTotal);
      titTxt = titTxt.replace('{{v-cart-count}}', vCartCount);
      $('.header-cart-btn .header-button-title').html(titTxt);
    }
    $root.on(confEvtDefault + ' lp-evt-header-cart-tit', changeCartTit);

    // Título atendimento
    function changeAtendTit() {
      const value = confTheme[ref]['header-atend-tit'];
      /* $(
        '.header-button-wrp-atendimento .header-button-title, .menu-mobile-footer-atendimento .menu-mobile-footer-tit',
      ).html(mdParse(value, true)); */
      $('.header-button-wrp-atendimento .header-button-title').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' lp-evt-header-atend-tit', changeAtendTit);

    // Título rastreamento
    function changeTrackTit() {
      const value = confTheme[ref]['header-track-tit'];
      //$('.header-rastreio-btn .header-button-title, .menu-mobile-rastreio').html(mdParse(value, true));
      $('.header-rastreio-btn .header-button-title').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' lp-evt-header-track-tit', changeTrackTit);

    // Header fixo
    function toggleHeaderFixed() {
      const value = confTheme[ref]['header-fixed'];
      const headerClass = value == 1 ? 'fixed' : '';
      const menuClass = value == 1 ? 'fixed' : '';
      $('#header').removeClass('fixed').addClass(headerClass);
      $('#menu').removeClass('fixed').addClass(menuClass);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-fixed', toggleHeaderFixed);

    // Header transparent
    function toggleHeaderTransparent() {
      const value = confTheme[ref]['header-transparent'];
      value == 1 ? $('body.home').addClass('header-transparent') : $('body.home').removeClass('header-transparent');
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-transparent', toggleHeaderTransparent);

    // Oculta/Exibe o login
    function changeLoginShow() {
      const value = confTheme[ref]['login-show'];
      value == '1' ? $loginLink.removeClass('d-none') : $loginLink.addClass('d-none');
      value == '1' ? $loginLinkMb.removeClass('d-none') : $loginLinkMb.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-login-show', changeLoginShow);
    function changeLoginMbShow() {
      const value = confTheme[ref]['login-mb-show'];
      value == '1' ? $loginLink.removeClass('d-none-sm d-none-xs') : $loginLink.addClass('d-none-sm d-none-xs');
    }
    $root.on(confEvtDefault + ' lp-evt-login-mb-show', changeLoginMbShow);

    // Ícone do login
    function changeLoginIcon() {
      const icon = confTheme[ref]['header-login-icon'];
      $('.header-login-btn .header-button-icon').html(getSvgIcon(icon));
    }
    $root.on(confEvtDefault + ' lp-evt-header-login-icon', changeLoginIcon);
    // Altera o tamanho do ícone
    function changeLoginIconSize() {
      const value = confTheme[ref]['styles']['header-login-icon-size'];
      $('#header')[0].style.setProperty('--header-login-icon-size', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-login-icon-size', changeLoginIconSize);

    // Título do login
    function changeLoginTit() {
      const value = confTheme[ref]['header-login-tit'];
      //$('.header-login-btn .header-button-title, .menu-mobile-login').html(mdParse(value, true));
      $('.header-login-btn .header-button-title').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' lp-evt-header-login-tit', changeLoginTit);
  }
})();

// ------------------------------------
// BARRA SUPERIOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';
    const ref2 = 'styles';

    // Elementos
    const $topBar = $('.header-bar');

    // Oculta/Exibe a barra superior
    function changeTopBarShow() {
      const value = confTheme[ref]['top-bar-show'];
      value == '1' ? $topBar.removeClass('d-none') : $topBar.addClass('d-none');
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-top-bar-show', changeTopBarShow);

    // Ativa/Desativa carrosel no computador
    function changeCarouselDesktop() {
      topBarDestroySlick();
      const value = confTheme[ref]['top-bar-carousel-desktop'];
      value == '1'
        ? $('.header-bar-content').addClass('carousel-desktop')
        : $('.header-bar-content').removeClass('carousel-desktop');
      setTimeout(topBarInitSlick, 100);
    }
    $root.on(confEvtDefault + ' lp-evt-top-bar-carousel-desktop', changeCarouselDesktop);

    // Ativa/Desativa carrosel vertical
    function changeCarouselVertical() {
      topBarDestroySlick();
      const value = confTheme[ref]['top-bar-carousel-vertical'];
      value == '1'
        ? $('.header-bar-content').addClass('carousel-vertical')
        : $('.header-bar-content').removeClass('carousel-vertical');
      setTimeout(topBarInitSlick, 100);
    }
    $root.on(confEvtDefault + ' lp-evt-top-bar-carousel-vertical', changeCarouselVertical);

    // Cor de fundo
    function changeTopBarBgColor() {
      const color = confTheme[ref][ref2]['header-bar-bg-color'];
      $topBar[0].style.setProperty('--header-bar-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-bar-bg-color', changeTopBarBgColor);

    // Cor do texto
    function changeTopBarTxtColor() {
      const color = confTheme[ref][ref2]['header-bar-txt-color'];
      $topBar[0].style.setProperty('--header-bar-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-bar-txt-color', changeTopBarTxtColor);

    // Cor dos ícones
    function changeTopBarIconsColor() {
      const color = confTheme[ref][ref2]['header-bar-icons-color'];
      $topBar[0].style.setProperty('--header-bar-icons-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-bar-icons-color', changeTopBarIconsColor);

    // Cor da borda
    function changeTopBarBorderColor() {
      const color = confTheme[ref][ref2]['header-bar-border-color'];
      $topBar[0].style.setProperty('--header-bar-border-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-header-bar-border-color', changeTopBarBorderColor);

    // Itens da lista
    function changeList() {
      const lista = confTheme[ref]['top-bar-itens'];
      const $list = $('.header-bar-content');
      $list.removeClass('center');
      if (lista.length == 1) {
        $list.addClass('center');
      }
      topBarDestroySlick();
      $list.html('');
      if ($list.length > 0) {
        for (let i = 0; i < lista.length; i++) {
          const itemIcon = lista[i].icon ? getSvgIcon(lista[i].icon) : '';
          let iconWidth = lista[i]?.icon_size || 12;
          const item = `
          <a href="${lista[i].url}" class="header-bar-item" style="--icon-width: ${iconWidth}px">
            <div class="header-bar-item-content">
              <div class="header-bar-item-icon">${itemIcon}</div>
              <div class="header-bar-item-txt">${mdParse(lista[i].text, true)}</div>
            </div>
          </a>`;
          $list.append(item);
        }
      }
      topBarInitSlick();
    }
    $root.on(confEvtDefault + ' lp-evt-top-bar-lista', changeList);
  }
})();

// ------------------------------------
// MENU
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';
    const ref2 = 'styles';

    // Elementos
    const $menu = $('#menu');
    const $menuSide = $('#header-menu');
    const $menuMb = $('#menu-mobile');

    // Tipo do menu
    function changeMenuType() {
      const value = confTheme[ref]['header-type'];
      const headerClass = value != 'default' ? value : '';
      $('#header').removeClass('header-simple header-center').addClass(headerClass);
      headerClass == 'header-simple' ? $menuSide.removeClass('d-none') : $menuSide.addClass('d-none');
      headerClass != 'header-simple' ? $menu.removeClass('d-none') : $menu.addClass('d-none');
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-type', changeMenuType);

    // Fonte weight
    function changeFontWeight() {
      const value = confTheme[ref][ref2]['menu-font-weight'];
      $root[0].style.setProperty('--menu-font-weight', value);
    }
    $root.on(confEvtDefault + ' lp-evt-menu-font-weight', changeFontWeight);

    // Cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['menu-bg-color'];
      $root[0].style.setProperty('--menu-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-menu-bg-color', changeBgColor);

    // Cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['menu-txt-color'];
      $root[0].style.setProperty('--menu-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-menu-txt-color', changeTxtColor);

    // Cor do hover
    function changeHvColor() {
      const color = confTheme[ref][ref2]['menu-txt-hv-color'];
      $root[0].style.setProperty('--menu-txt-hv-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-menu-txt-hv-color', changeHvColor);

    // Cor da borda
    function changeBorderColor() {
      const color = confTheme[ref][ref2]['menu-border-color'];
      $root[0].style.setProperty('--menu-border-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-menu-border-color', changeBorderColor);

    // Efeito underline
    function changeUnderlineEffect() {
      const value = confTheme[ref]['menu-underline'];
      value == '1'
        ? $('#header-menu, .menu-full-container').addClass('menu-underline')
        : $('#header-menu, .menu-full-container').removeClass('menu-underline');
    }
    $root.on(confEvtDefault + ' lp-evt-menu-underline', changeUnderlineEffect);

    // Popula itens do menu
    function populaMenu() {
      const lista = confTheme[ref]['menu-links'];
      const $list = $menu.find('.menu-full-container > ul');
      const menuLinks = [];
      if ($menu.length > 0) {
        for (let i = 0; i < lista.length; i++) {
          const menuItem = lista[i];
          // Menu padrão
          if (menuItem['tipo_link'] == 'default') {
            menuLinks.push({
              title: menuItem['titulo'],
              url: menuItem['url'],
              has_sub: false,
              submenu: [],
            });
          }
          // Menu página institucional
          else if (menuItem['tipo_link'] == 'page') {
            let pageMenu = false;
            if (pagesHome && pagesHome.length > 0) {
              pageMenu = pagesHome.filter((pag) => pag.id == menuItem['url'])[0];
            }
            if (pageMenu) {
              menuLinks.push({
                title: pageMenu['titulo'],
                url: pageMenu['url'],
                has_sub: false,
                submenu: [],
              });
            }
          }
          // Menu coleção
          else if (menuItem['tipo_link'] == 'collection') {
            let colMenu = false;
            if (collectionsHome && collectionsHome.length > 0) {
              colMenu = collectionsHome.filter((col) => col.id == menuItem['url'])[0];
            }
            if (colMenu) {
              menuLinks.push({
                title: colMenu['title'],
                url: colMenu['url'],
                has_sub: false,
                submenu: [],
              });
            }
          }
          // Menu marcas
          else if (menuItem['tipo_link'] == 'brands') {
            if (brandsHome && brandsHome.length > 0) {
              let submenuBrands = [];
              brandsHome.forEach((brand) => {
                submenuBrands.push({
                  title: brand['title'],
                  url: brand['url'],
                });
              });
              menuLinks.push({
                title: menuItem['titulo'],
                url: '#',
                has_sub: true,
                submenu: submenuBrands,
              });
            }
          }
          // Menu categoria
          else if (menuItem['tipo_link'] == 'category') {
            let catMenu = false;
            let submenuCats = [];
            if (categoriasHome && categoriasHome.length > 0) {
              catMenu = categoriasHome.filter((cat) => cat.id == menuItem['url'])[0];
              if (catMenu && catMenu.subcategories && catMenu.subcategories.length > 0) {
                catMenu.subcategories.forEach((sub) => {
                  submenuCats.push({
                    title: sub['title'],
                    url: sub['url'],
                  });
                });
              } else {
                categoriasHome.forEach((cat) => {
                  if (cat.subcategories && cat.subcategories.length > 0) {
                    cat.subcategories.forEach((sub) => {
                      if (sub.id == menuItem['url']) {
                        menuLinks.push({
                          title: sub['title'],
                          url: sub['url'],
                          has_sub: false,
                          submenu: [],
                        });
                      }
                    });
                  }
                });
              }
            }
            if (catMenu) {
              menuLinks.push({
                title: catMenu['title'],
                url: catMenu['url'],
                has_sub: submenuCats && submenuCats.length > 0,
                submenu: submenuCats,
              });
            }
          }
          // Menu blog
          else if (menuItem['tipo_link'] == 'blog') {
            menuLinks.push({
              title: menuItem['titulo'],
              url: '',
              has_sub: false,
              submenu: [],
            });
          }
          // Menu pedidos
          else if (menuItem['tipo_link'] == 'orders') {
            menuLinks.push({
              title: menuItem['titulo'],
              url: '',
              has_sub: false,
              submenu: [],
            });
          }
        }
      }
      $list.html('');
      if ($list.length > 0 && menuLinks.length > 0) {
        menuLinks.forEach((menuItem) => {
          const hasSubClass = menuItem.has_sub ? 'has-sub' : '';
          const subArrow = menuItem.has_sub ? '<span class="arrow"></span>' : '';
          let $submenu = '';
          if (menuItem.has_sub && menuItem.submenu.length > 0) {
            $submenu += '<ul class="menu-full-sub">';
            menuItem.submenu.forEach((subItem) => {
              $submenu += `<li><a href="${subItem.url}">${subItem.title}</a></li>`;
            });
            $submenu += '</ul>';
          }
          const $menuItem = $(
            `<li class="${hasSubClass}"><a href="${menuItem.url}">${menuItem.title}${subArrow}</a>${$submenu}</li>`,
          );
          $list.append($menuItem);
        });
      }
      const $listSide = $menuSide.find('ul').first();
      $listSide.html('');
      if ($listSide.length > 0 && menuLinks.length > 0) {
        menuLinks.forEach((menuItem) => {
          const hasSubClass = menuItem.has_sub ? 'has-sub' : '';
          const subArrow = menuItem.has_sub ? '<span class="arrow"></span>' : '';
          let $submenu = '';
          if (menuItem.has_sub && menuItem.submenu.length > 0) {
            $submenu += '<ul class="header-menu-sub">';
            menuItem.submenu.forEach((subItem) => {
              $submenu += `<li><a href="${subItem.url}">${subItem.title}</a></li>`;
            });
            $submenu += '</ul>';
          }
          const $menuItem = $(
            `<li class="${hasSubClass}"><a href="${menuItem.url}">${menuItem.title}${subArrow}</a>${$submenu}</li>`,
          );
          $listSide.append($menuItem);
        });
      }
      const $listMb = $menuMb.find('.menu-mobile > .menu-mobile-nav');
      $listMb.children('li:not(.menu-mobile-footer)').remove();
      if ($listMb.length > 0 && menuLinks.length > 0) {
        menuLinks.reverse();
        menuLinks.forEach((menuItem) => {
          const hasSubClass = menuItem.has_sub ? 'has-sub' : '';
          let $submenu = '';
          if (menuItem.has_sub && menuItem.submenu.length > 0) {
            $submenu += `<ul class="is-hidden">
              <li class="go-back"><a href="#">Voltar</a></li>
              <li class="see-all"><a href="${menuItem.url}">${menuItem.title}</a></li>`;
            menuItem.submenu.forEach((subItem) => {
              $submenu += `<li><a href="${subItem.url}">${subItem.title}</a></li>`;
            });
            $submenu += '</ul>';
          }
          const $menuItem = $(
            `<li class="${hasSubClass}"><a href="${menuItem.url}">${menuItem.title}</a>${$submenu}</li>`,
          );
          $listMb.prepend($menuItem);
        });
      }
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-lista', populaMenu);
  }
})();

// ------------------------------------
// BANNER TOPO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header';

    // Elementos
    const $banner = $('.header-banner');
    const $bannerImg = $('.header-banner-img');

    // Oculta/Exibe o banner
    function changeBannerShow() {
      const value = confTheme[ref]['banner-top-show'];
      value == '1' ? $banner.removeClass('d-none') : $banner.addClass('d-none');
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-show', changeBannerShow);

    // Altera a imagem
    function changeBannerImage() {
      const image = confTheme[ref]['banner-top-img'];
      $bannerImg.css('background-image', 'url(' + image + ')');
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-img', changeBannerImage);

    // Altera o tamanho da imagem
    function changeBannerSize() {
      const value = confTheme[ref]['styles']['banner-top-height'];
      $banner[0].style.setProperty('--header-banner-height', value);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-height', changeBannerSize);
    function changeBannerSizeMb() {
      const value = confTheme[ref]['styles']['banner-top-height-mb'];
      $banner[0].style.setProperty('--header-banner-height-mb', value);
      setBodyPdTop();
      setMenuMbTop();
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-height-mb', changeBannerSizeMb);

    // Altera o link do banner
    function changeBannerUrl() {
      const value = confTheme[ref]['banner-top-url'];
      $banner.attr('href', value);
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-url', changeBannerUrl);

    // Ativa/Desativa animação
    function changeBannerAnimation() {
      const value = confTheme[ref]['banner-top-animated'];
      value == '1' ? $bannerImg.addClass('animated') : $bannerImg.removeClass('animated');
    }
    $root.on(confEvtDefault + ' lp-evt-header-banner-top-animated', changeBannerAnimation);
  }
})();
